import { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { X } from "lucide-react";
import { api, errMsg, img } from "@/lib/api";

export const REQUEST_TYPES = [
  ["informazioni", "Richiesta commerciale / informazioni"], ["prodotto", "Informazioni su un prodotto"], ["ordine", "Ordine"],
  ["spedizione", "Spedizione"], ["reso", "Reso / recesso"], ["garanzia", "Garanzia"], ["assistenza", "Assistenza tecnica"], ["altro", "Altro"],
];
const field = "h-11 w-full rounded-xl border border-slate-200 bg-slate-50 px-4 text-sm text-slate-900 outline-none focus:border-[#0066FF] focus:bg-white";

export const RequestForm = ({ defaultType = "informazioni", withPhotos = false }) => {
  const [f, setF] = useState({ type: defaultType, name: "", email: "", phone: "", order_number: "", product: "", message: "", photos: [], privacy: false });
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(null);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.type === "checkbox" ? e.target.checked : e.target.value });

  const upload = async (e) => {
    const files = Array.from(e.target.files || []).slice(0, 5 - f.photos.length);
    for (const file of files) {
      const fd = new FormData();
      fd.append("file", file);
      try {
        const { data } = await api.post("/requests/upload", fd);
        setF((x) => ({ ...x, photos: [...x.photos, data.url] }));
      } catch (err) {
        toast.error(errMsg(err));
      }
    }
    e.target.value = "";
  };
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const { data } = await api.post("/requests", f);
      setDone(data.number);
    } catch (err) {
      toast.error(errMsg(err));
    } finally {
      setBusy(false);
    }
  };

  if (done) return <div className="rounded-3xl border border-[#0066FF]/30 bg-[#0066FF]/5 p-8 text-slate-900" data-testid="request-success">Richiesta <b>{done}</b> inviata. Ti risponderemo ai recapiti indicati.</div>;
  return (
    <form onSubmit={submit} className="space-y-3" data-testid="request-form">
      <select value={f.type} onChange={set("type")} className={field} data-testid="request-type">{REQUEST_TYPES.map(([v, l]) => <option key={v} value={v}>{l}</option>)}</select>
      <div className="grid gap-3 sm:grid-cols-2">
        <input required value={f.name} onChange={set("name")} placeholder="Nome e cognome *" className={field} data-testid="request-name" />
        <input required type="email" value={f.email} onChange={set("email")} placeholder="Email *" className={field} data-testid="request-email" />
        <input value={f.phone} onChange={set("phone")} placeholder="Telefono" className={field} data-testid="request-phone" />
        <input value={f.order_number} onChange={set("order_number")} placeholder="Numero ordine (se presente)" className={field} data-testid="request-order" />
      </div>
      <input value={f.product} onChange={set("product")} placeholder="Prodotto" className={field} data-testid="request-product" />
      <textarea required minLength={10} rows={5} value={f.message} onChange={set("message")} placeholder="Descrivi la tua richiesta o il problema *" className={field + " h-auto py-3"} data-testid="request-message" />
      {withPhotos && (
        <div>
          <div className="flex flex-wrap gap-2">
            {f.photos.map((u) => (
              <span key={u} className="relative h-16 w-16 overflow-hidden rounded-lg border border-slate-200">
                <img src={img(u)} alt="" className="h-full w-full object-cover" />
                <button type="button" onClick={() => setF({ ...f, photos: f.photos.filter((x) => x !== u) })} className="absolute right-0 top-0 bg-black/60 p-0.5 text-white" aria-label="Rimuovi foto"><X className="h-3 w-3" /></button>
              </span>
            ))}
            {f.photos.length < 5 && (
              <label className="flex h-16 cursor-pointer items-center rounded-lg border border-dashed border-slate-300 px-3 text-xs text-slate-500 hover:border-[#0066FF]">
                + Foto (max 5)<input type="file" accept="image/*" multiple className="hidden" onChange={upload} data-testid="request-photo-input" />
              </label>
            )}
          </div>
        </div>
      )}
      <label className="flex items-start gap-2 text-xs text-slate-600">
        <input type="checkbox" checked={f.privacy} onChange={set("privacy")} required className="mt-0.5 accent-[#0066FF]" data-testid="request-privacy" />
        <span>Ho letto la <Link to="/pagina/privacy" className="text-[#0066FF] underline">Privacy Policy</Link> e acconsento al trattamento dei dati per rispondere alla richiesta.</span>
      </label>
      <button disabled={busy} className="h-12 rounded-full bg-[#0066FF] px-8 font-semibold text-white transition-colors hover:bg-[#1a75ff] disabled:opacity-50" data-testid="request-submit">
        {busy ? "Invio…" : "Invia richiesta"}
      </button>
    </form>
  );
};
